import { apiClient, Auth } from '@/shared/api'

import { TRoomsCountSearchParams, TRoomsCountResponse } from './schema'

export const getRoomsCount = async (params: TRoomsCountSearchParams) => {
  const { data } = await apiClient.get<TRoomsCountResponse>({
    endpoint: `/rooms/count`,
    queryParams: params,
    auth: Auth.NONE, // 실제로는 Optional이지만 개수 조회에 인증이 필요하지 않으므로 None으로 설정
  })

  return data
}
